import React from 'react';

import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Flex,
  Icon,
} from '@chakra-ui/react';

import {
  FaBox,
  FaCheckCircle,
  FaHourglassHalf,
  FaLink,
  FaListUl,
  FaCarSide,
  FaBan,
} from 'react-icons/fa';

import { useColors } from './colors';

const SummaryStats = ({ overview }) => {
  const {
    textColor,
    backgroundCardColor,
    secondaryTextColor,
    successColor,
    pendingColor,
    accentColor,
  } = useColors();

  const stats = [
    {
      label: 'Total SKUs',
      value: overview.totalSkus,
      helpText: 'Catalog SKUs',
      icon: FaBox,
      color: accentColor,
    },
    {
      label: 'Optimized',
      value: overview.optimizedSkus,
      helpText: 'Fully verified',
      icon: FaCheckCircle,
      color: successColor,
    },
    {
      label: 'Pending',
      value: overview.pendingSkus,
      helpText: 'Eligible next run',
      icon: FaHourglassHalf,
      color: pendingColor,
    },
    {
      label: 'Halted',
      value: overview.haltedSkus ?? 0,
      helpText: '3+ failed runs',
      icon: FaBan,
      color: 'purple.500',
    },
    {
      label: 'Linked listings',
      value: overview.linkedListings,
      helpText: 'Tied to SKUs',
      icon: FaLink,
      color: 'blue.500',
    },
    {
      label: 'Item specifics',
      value: overview.verifiedItemSpecificsSkus,
      helpText: 'Optimizer verified',
      icon: FaListUl,
      color: 'teal.500',
    },
    {
      label: 'Fitment',
      value: overview.verifiedFitmentSkus,
      helpText: 'Optimizer verified',
      icon: FaCarSide,
      color: 'cyan.600',
    },
  ];

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={3}>
      {stats.map((stat) => (
        <Box
          key={stat.label}
          p={4}
          bg={backgroundCardColor}
          borderRadius="lg"
          boxShadow="sm"
          borderWidth="1px"
          borderColor="transparent"
        >
          <Flex justify="space-between" align="center" gap={2}>
            <Stat size="sm" flex="1" minW={0}>
              <StatLabel color={textColor} fontSize="xs" mb={0.5} noOfLines={1}>
                {stat.label}
              </StatLabel>
              <StatNumber color={textColor} fontSize="xl" lineHeight="1.2">
                {stat.value.toLocaleString()}
              </StatNumber>
              <StatHelpText
                color={secondaryTextColor}
                fontSize="xs"
                mb={0}
                mt={0.5}
                noOfLines={1}
              >
                {stat.helpText}
              </StatHelpText>
            </Stat>
            <Icon as={stat.icon} boxSize={7} color={stat.color} flexShrink={0} />
          </Flex>
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default SummaryStats;
